import { render, staticRenderFns } from "./TextLengthLimitations.vue?vue&type=template&id=67db6582&"
import script from "./TextLengthLimitations.vue?vue&type=script&lang=js&"
export * from "./TextLengthLimitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports